// IELTS Mock 7 — Academic Speaking
// Same shape as IELTS_DATA_SPEAKING in ../IeltsSpeaking.js.
const IELTS_MOCK7_SPEAKING = {
  title: "Academic Speaking Practice Test 7",
  parts: [
    {
      id: "part1",
      title: "Part 1: Introduction & Interview (4-5 min)",
      questions: [
        "Let's talk about your daily routine. What is the busiest part of your day?",
        "Has your routine changed much in the last few years?",
        "Let's talk about writing. Do you prefer writing by hand or typing? Why?",
        "When was the last time you wrote something by hand?",
        "Do you think handwriting is still important for children to learn?"
      ]
    },
    {
      id: "part2",
      title: "Part 2: Long Turn (Cue Card) (3-4 min)",
      prompt: "Describe a piece of technology that you find difficult to live without. You should say: What it is, When you started using it, How often you use it, and explain why it is so important to you.",
      preparationTime: 60,
      speakingTime: 120
    },
    {
      id: "part3",
      title: "Part 3: Discussion (4-5 min)",
      questions: [
        "Why do you think people find it hard to put down their phones?",
        "Should technology companies be responsible for how much time people spend on their products?",
        "How has technology changed the way families spend time together?",
        "Do you think older people and younger people use technology differently? In what ways?",
        "What kinds of technology do you think will be most important in the next twenty years?"
      ]
    }
  ]
};

export default IELTS_MOCK7_SPEAKING;
